/**
 * UCM报文管理模块入口
 * 导出UCM报文管理相关的所有组件
 */

import UcmManagementPage from './UcmManagementPage';

export { UcmManagementPage };
export default UcmManagementPage;

